<template>
  <div class="show_all_content_wrapper">
    <!-- Start:: Main Section -->
    <main>
      <!--  =========== Start:: Filter Form =========== -->

      <!--  =========== End:: Filter Form =========== -->

      <!--  =========== Start:: Table Title =========== -->
      <div class="table_title_wrapper">
        <div class="title_text_wrapper">
          <h5>
            {{ $t("PLACEHOLDERS.packagesUser", { name: userName ?? "-" }) }}
          </h5>
          <button
            v-if="!filterFormIsActive"
            class="filter_toggler"
            @click.stop="filterFormIsActive = !filterFormIsActive"
          >
            <i class="fal fa-search"></i>
          </button>
        </div>
      </div>
      <!--  =========== End:: Table Title =========== -->

      <!--  =========== Start:: Data Table =========== -->
      <v-data-table
        class="thumb"
        :loading="loading"
        :loading-text="$t('TABLES.loadingData')"
        :search="searchValue"
        :headers="tableHeaders"
        :items="tableRows"
        item-class="ltr"
        :items-per-page="500000"
        hide-default-footer
      >
        <template v-slot:no-data>
          {{ $t("TABLES.noData") }}
        </template>

        <template v-slot:[`item.id`]="{ item, index }">
          <p class="blue-grey--text text--darken-1 fs-3" v-if="!item.id">-</p>
          <p v-else>
            {{
              (paginations.current_page - 1) * paginations.items_per_page +
              index +
              1
            }}
          </p>
        </template>
        <template v-slot:[`item.start_date`]="{ item }">
          {{ formatDateOnly(item?.start_date) }}
        </template>
        <template v-slot:[`item.end_date`]="{ item }">
          {{ formatDateOnly(item?.start_date) }}
        </template>
        <template v-slot:[`item.price_without_vat`]="{ item }">
          {{ item.price - item.vat }}
        </template>
        <!-- Start:: Activation -->
        >
        <!-- End:: Activation -->
      </v-data-table>
      <!--  =========== End:: Data Table =========== -->
    </main>
    <!-- End:: Main Section -->
  </div>
</template>

<script>
import { debounce } from "lodash";
import { mapGetters } from "vuex";

export default {
  name: "UserSubscriptions",

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
    }),
  },

  data() {
    return {
      activeStatuses: [
        {
          id: 1,
          name: this.$t("STATUS.active"),
          value: 1,
        },
        {
          id: 2,
          name: this.$t("STATUS.notActive"),
          value: false,
        },
      ],
      // Start:: Loading Data
      loading: false,
      selected: [],
      isWaitingRequest: false,
      myHeaderCheck: false,
      userName: "",
      // End:: Loading Data
      allSelected: false,

      // Start:: Filter Data
      filterFormIsActive: false,
      filterOptions: {
        name: null,
        state: null,
        is_active: null,
      },
      // End:: Filter Data

      // Start:: Table Data
      searchValue: "",
      tableHeaders: [
        {
          text: this.$t("TABLES.Admins.serialNumber"),
          value: "id",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("PLACEHOLDERS.package_name"),
          value: "package.name",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.from"),
          value: "start_date",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.to"),
          value: "end_date",
          sortable: false,
          align: "center",
        },

        {
          text: this.$t("PLACEHOLDERS.price_without_vat"),
          value: "price_without_vat",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.total_price_with_vat"),
          value: "price",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.total_tax_value"),
          value: "vat",
          sortable: false,
          align: "center",
        },
      ],
      tableRows: [],
      // End:: Table Data

      // Start:: Pagination Data
      paginations: {
        current_page: 1,
        last_page: 1,
        items_per_page: 10,
      },
      // End:: Pagination Data
    };
  },

  methods: {
    formatDateOnly(date) {
      const d = typeof date === "string" ? new Date(date) : date;
      return d.toISOString().split("T")[0];
    },

    // Start:: Set Table Rows

    async setTableRows() {
      this.loading = true;
      try {
        let res = await this.$axios({
          method: "GET",
          url: `reports/subscriptions/${this.$route.params.id}`,
        });
        this.selected = [];
        this.loading = false;
        this.tableRows = res.data.data[0];
        this.userName = res.data.data[0]?.[0]?.user?.user.name;
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
  },

  created() {
    // Start:: Fire Methods
    window.addEventListener("click", () => {
      // this.filterFormIsActive = false;
    });
    if (this.$route.query.page) {
      this.paginations.current_page = +this.$route.query.page;
    }
    this.setTableRows();
    // End:: Fire Methods
  },
};
</script>
